<template>
  <landing>
    <div>
      <b-card
        title="Σφάλμα"
        tag="article"
        style="max-width: 20rem;"
        class="mb-2"
      >
        <b-card-text>
          Παρουσιάστηκε κάποιο σφάλμα. Παρακαλούμε προσπαθήστε ξανά.
        </b-card-text>

        <b-button
          variant="primary"
          @click="$router.push({ name: 'GettingReady' })"
          >Ξαναπροσπαθήστε</b-button
        >
      </b-card>
    </div>
  </landing>
</template>

<script>
import Landing from '@/components/Landing.vue';

export default {
  name: 'ErrorPage',
  components: {
    Landing
  }
};
</script>
